import type { ProcessableImageType, ProcessableServerImageType } from '@/lib/types/common.types'

export const STATUS_TITLE_MAP: Record<NotificationStatus, string> = {
  suggestion: 'Suggestions',
  second_prio: 'Second prio',
  open: 'Invited',
  applied: 'Applied',
  accepted: 'Approved',
  store_denied: 'Rejected by advertiser',
  denied: 'Rejected by creator',
  product_sent: 'Product sent',
  have_received: 'Product received',
  have_posted: 'Posted',
  done: 'Done',
}
export enum NotificationStatus {
  OPEN = 'open',
  APPLIED = 'applied',
  DENIED = 'denied',
  ACCEPTED = 'accepted',
  STORE_DENIED = 'store_denied',
  DONE = 'done',
  SUGGESTION = 'suggestion',
  SECOND_PRIO = 'second_prio',
  HAVE_POSTED = 'have_posted',
  HAVE_RECEIVED = 'have_received',
  PRODUCT_SENT = 'product_sent',
}

export enum NotificationActionType {
  StatusUpdate = 'status-update',
  CommentCreate = 'comment-create',
  ParticipantAdded = 'participant-added',
}

export type NotificationAction =
  | {
      type: NotificationActionType.StatusUpdate
      oldStatus: NotificationStatus
      newStatus: NotificationStatus
    }
  | {
      type: NotificationActionType.CommentCreate
      commentId: string
      commentText: string
    }
  | {
      type: NotificationActionType.ParticipantAdded
    }

export type NotificationServerType = {
  id: string
  subscriber_id: string
  read: boolean
  data: {
    events: {
      id: string
      time: string
      payload: {
        _identifier: string
        actor: {
          id: string
          name: string
          subscriberId: string
        }
        action: NotificationAction
        campaign: {
          id: number
          name: string
        }
        participant: {
          id: string
          name: string
          avatar?: ProcessableServerImageType
        }
        advertiser: {
          id: string
          name: string
          logo?: ProcessableServerImageType
        }
      }
    }[]
  }
  created_at: string
}

export type NotificationType = {
  id: string
  read: boolean
  data: {
    events: {
      id: string
      time: string
      payload: {
        _identifier: string
        actor: {
          id: string
          name: string
          subscriberId: string
        }
        action: NotificationAction
        campaign: {
          id: number
          name: string
        }
        participant: {
          id: string
          name: string
          avatar?: ProcessableImageType
        }
        advertiser: {
          id: string
          name: string
          logo?: ProcessableImageType
        }
      }
    }[]
  }
  createdAt: string
}

export enum RequestStatus {
  Idle = 'idle',
  Loading = 'loading',
  Success = 'success',
  Error = 'error',
}
